import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  fullscreenToggleButtonContainer: {
    width: (props) => props.width,
    height: (props) => (props.showIcon ? '14px' : 0),
    opacity: (props) => (props.showIcon ? 1 : 0),
    transition: `all .2s ${theme.transitions.easing.easeInOut}`,
    position: 'fixed',
    top: 0,
    left: (props) => `calc(50% - ${props.width / 2}px)`,
    textAlign: 'center',
    lineHeight: '14px',
    zIndex: 10001,
    border: 'none',
  },
  FullscreenToggleButton: {
    padding: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.evPalette.ocean['100'],
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: '0 0 8px 8px',
    '&:hover': {
      backgroundColor: theme.evPalette.ocean['200'],
      transition: 'background-color 100ms linear',
    },
    '&:hover #less_1': { animation: `$less_up 300ms ${theme.transitions.easing.easeInOut}` },
    '&:hover #less_2': { animation: `$less_down 300ms ${theme.transitions.easing.easeInOut}` },
    '&:hover #more_1': { animation: `$more_up 300ms ${theme.transitions.easing.easeInOut}` },
    '&:hover #more_2': { animation: `$more_down 300ms ${theme.transitions.easing.easeInOut}` },
  },
  icon: {
    fill: theme.evPalette.ocean['800'],
    height: '14px',
  },
  iconLess1: {
    position: 'absolute',
    opacity: 1,
    top: '-8px',
  },
  iconLess2: {
    position: 'absolute',
    opacity: 0,
    top: '-2px',
  },
  iconMore1: {
    position: 'absolute',
    opacity: 1,
    top: '-8px',
  },
  iconMore2: {
    position: 'absolute',
    opacity: 0,
    top: '-16px',
  },
  '@keyframes less_up': {
    '0%': {
      opacity: '100%',
      top: '-8px',
    },
    '50%': {
      opacity: '100%',
      top: '-12px',
    },
    '100%': {
      opacity: '0',
      top: '-16px',
    },
  },
  '@keyframes less_down': {
    '0%': {
      opacity: '0%',
      top: '-2px',
    },
    '25%': {
      opacity: '0%',
      top: '-3px',
    },
    '50%': {
      opacity: '100%',
      top: '-4px',
    },
    '75%': {
      opacity: '100%',
      top: '-6px',
    },
    '95%': {
      opacity: '100%',
      top: '-7px',
    },
    '100%': {
      opacity: '100px',
      top: '-8px',
    },
  },
  '@keyframes more_up': {
    '0%': {
      opacity: '100%',
      top: '-8px',
    },
    '50%': {
      opacity: '100%',
      top: '-4px',
    },
    '100%': {
      opacity: '0',
      top: '-2px',
    },
  },
  '@keyframes more_down': {
    '0%': {
      opacity: '0%',
      top: '-16px',
    },
    '25%': {
      opacity: '0%',
      top: '-14px',
    },
    '50%': {
      opacity: '100%',
      top: '-12px',
    },
    '75%': {
      opacity: '100%',
      top: '-10px',
    },
    '95%': {
      opacity: '100%',
      top: '-9px',
    },
    '100%': {
      opacity: '100px',
      top: '-8px',
    },
  },
}));
